import React, { useEffect } from 'react';

import { Table } from 'antd';

import { useOrder } from '@hooks/OrdersContext';

import { columns } from '../../columns';
import OrderItemsTabs from '../OrderItemsTabs';

const CanceledTab: React.FC = () => {
  const { canceledPage, canceledOrders, loadCanceledOrders, canceledTotal, loadingCanceledOrders, canceledFilters } =
    useOrder();

  useEffect(() => {
    loadCanceledOrders(0);
  }, []);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      canceledFilters.field = `${sorter.field}`;
      canceledFilters.order = `${sorter.order}`;
    }

    loadCanceledOrders(pagination.current, canceledFilters);
  };

  return (
    <Table
      columns={columns}
      dataSource={canceledOrders}
      pagination={{
        pageSize: 10,
        total: canceledTotal,
        current: canceledPage,
        showSizeChanger: false,
        showQuickJumper: false,
      }}
      onChange={handleTableChange}
      loading={loadingCanceledOrders}
      expandable={{
        expandedRowRender: (record) => <OrderItemsTabs order={record} option="canceled" />,
      }}
      scroll={{ x: 800 }}
      rowKey={(record) => record.orderCode}
    />
  );
};

export default CanceledTab;
